import UsersUploadDispatcherFactory from './UsersUploadDispatcherFactory';
import { IUsersUploadDispatcherFactoryMethod as IUsersUploadDispatcherFactory } from './interfaces';
import { DIUploadTypes } from '../types';

export const { UsersUploadDispatcher } = DIUploadTypes;

export type { IUsersUploadDispatcherFactory };

export default UsersUploadDispatcherFactory;
